import { useState, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

export default function useMarketQuotas() {
  const [quotas, setQuotas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const fetchQuotas = useCallback(async (params = {}) => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/market/quotas/`, { params });
      setQuotas(res.data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, []);

  const createQuota = useCallback(async (data) => {
    setSaving(true);
    try {
      const res = await axios.post(`${API}/market/quotas/`, {
        ...data,
        min_price: data.min_price || null,
      });
      setQuotas(prev => [res.data, ...prev]);
      return res.data;
    } finally { setSaving(false); }
  }, []);

  const updateQuota = useCallback(async (id, data) => {
    setSaving(true);
    try {
      const res = await axios.patch(`${API}/market/quotas/${id}/`, data);
      setQuotas(prev => prev.map(q => q.id === id ? res.data : q));
      return res.data;
    } finally { setSaving(false); }
  }, []);

  return { quotas, loading, saving, fetchQuotas, createQuota, updateQuota };
}
